/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */


import React, { useState, useRef, useMemo } from 'react';
import { useEditModeManager } from '../../../../../../../../../common/hooks';
import editModeManager from '../../../../../../../../../common/utils/EditModeManager';
import { ElevateVideoPlaceholder } from '../../../../../../../../SplashRenderer';

import { NoEditMode } from '../../../Actions';
import useOuterClick from '../../../../../../hooks/useOuterClick';
import { RelativeBlock } from '../common/StyledEditables';







const ShootstaPlayer = (props) => {
  const { moduleId, rowId, columnId } = props;

  const componentId = useMemo(() => `shootstaplayer-${moduleId || 'unknown'}-${rowId || 'unknown'}-${columnId || 'unknown'}`, [moduleId, rowId, columnId]);

  const componentRef = useRef();
  const [canEdit, setShowEdit] = useState(false);

  const showEdit = (e) => {
    e.stopPropagation();
    editModeManager.setActiveComponent(componentId);
    setShowEdit(true);
  };

  const handleOuterClick = () => {
    if (!canEdit) {
      return;
    }

    editModeManager.clearActiveComponent();
    setShowEdit(false);
  };

  useOuterClick({ dependencies: [canEdit], callback: handleOuterClick, innerRef: componentRef });

  useEditModeManager({
    componentId,
    callbackToHide: () => {
      setShowEdit(false);
    },
    optionalConditionToHide: canEdit,
    dependencies: [canEdit]
  });

  return (
    <RelativeBlock ref={componentRef}>
      <div
        tabIndex="0"
        onClick={showEdit}
        role="button"
        aria-pressed="false"
        onKeyDown={() => undefined}>

        <ElevateVideoPlaceholder />
      </div>
      {canEdit && <NoEditMode />}
    </RelativeBlock>);

};


export default ShootstaPlayer;